import React from 'react';
import history from 'app/routes/history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import RenderContent from 'app/components/layout/RenderContent';
import Header from 'app/components/layout/Header';
import Button from 'app/components/general/Button';
import ManageClubTeams from 'app/features/manage-club/components/ManageClubTeams';
import ManageClubPayments from 'app/features/manage-club/components/ManageClubPayments';
// import ManageClubNotifications from 'app/features/manage-team/components/ManageClubNotifications';

import * as teamActions from 'app/ducks/teams/actions';
import * as clubActions from 'app/ducks/clubs/actions';
import * as paymentActions from 'app/ducks/payments/actions';
import * as paymentCollectionActions from 'app/ducks/paymentCollections/actions';
import * as reminderActions from 'app/ducks/reminders/actions';

import * as teamSelectors from 'app/ducks/teams/selectors';
import * as clubSelectors from 'app/ducks/clubs/selectors';
import * as paymentSelectors from 'app/ducks/payments/selectors';
import * as paymentCollectionSelectors from 'app/ducks/paymentCollections/selectors';
import * as reminderSelectors from 'app/ducks/reminders/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';

function selector(state): any {
  return {
    teams: {
      ...teamSelectors.getTeams(state),
    },
    clubs: clubSelectors.getClubs(state),
    payments: paymentSelectors.getPayments(state),
    paymentCollections: paymentCollectionSelectors.getPaymentCollections(state),
    reminders: reminderSelectors.getReminders(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamActions,
  clubActions,
  paymentActions,
  paymentCollectionActions,
  reminderActions,
);

interface IManageClubLayoutProps {
  actions: any;
  clubs: any;
  payments: any;
  teams: any;
  paymentCollections: any;
  reminders: any;
  match: any;
}
@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class ManageClubLayout extends React.Component<
  IManageClubLayoutProps
> {
  static defaultProps: IManageClubLayoutProps = {
    actions: undefined,
    clubs: undefined,
    payments: undefined,
    teams: undefined,
    paymentCollections: undefined,
    reminders: undefined,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent className="manage-club-app" match={this.props.match}>
        <div className="row">
          <div className="col">
            <Header
              title="Manage Club"
              subtitle={this.props.clubs.currentClub.name}
            />
          </div>
          <div className="col ">
            <div className="d-flex flex-column justify-content-center align-items-end h-100">
              <Button
                className="btn-2 btn-thin"
                onClick={() => history.push(`/clubs/${this.props.clubs.currentClub.id}/edit`)}
              >
                Edit Club
              </Button>
            </div>
          </div>
        </div>
        {/* <ManageClubNotifications
          actions={this.props.actions}
          currentTeam={this.props.clubs.currentClub}
        /> */}
        <div className="row">
          <div className="col">
            <h3>Teams</h3>
            <ManageClubTeams
              {...this.props}
            />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <h3>Payment Requests</h3>
            <ManageClubPayments {...this.props} />
          </div>
        </div>
      </RenderContent>
    );
  }
}
